import twitter from 'twitter-text'

import type { MentionEntity } from '../common'

import styles from './helpers.module.css'

/**
 * Substack Notes link URLs only. Hashtags and handles stay plain text, so a
 * shared parser that linkifies them would show links Substack never renders.
 */
export const parseSubstackLinks = (text: string): MentionEntity[] => {
  if (!text) return []

  return twitter.extractUrlsWithIndices(text).map((entity) => ({
    // Substack hides the scheme and shows the rest of the URL whole
    displayString: entity.url.replace(/^https?:\/\//i, ''),
    indices: entity.indices,
    rawString: entity.url,
    url: entity.url,
    className: styles.link,
  }))
}
